import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    Grid,
    Typography,
    IconButton,
    CircularProgress, Divider, Paper
} from "@mui/material";
import { IoAlertCircle, IoClose } from "react-icons/io5";
import { MdPersonOutline } from "react-icons/md";
import "./ReturnCommentPopup.css";
import axios from "axios";

const ReturnCommentPopupFlowHeadOfDepartment = ({ flow, userId, fileId }) => {
    const [open, setOpen] = useState(false);
    const [userDetails, setUserDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchUserDetails = async (userId) => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetOneUserByID?UserID=${userId}`);
            const userData = response.data.data;
            setUserDetails(prevDetails => ({
                ...prevDetails,
                [userId]: userData
            }));
        } catch (error) {
            console.error('Failed to fetch user details:', error);
            setError('Failed to load user details.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        flow.forEach(item => {
            if (!userDetails[item.requesterId]) {
                fetchUserDetails(item.requesterId);
            }
        });
    }, [flow]);

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Tooltip title="დახარვეზების მიზეზი">
                <IconButton onClick={handleClickOpen} className="alert-icon-return_comment">
                    <IoAlertCircle />
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="return-comment-dialog-title"
                aria-describedby="return-comment-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="return-comment-dialog-title" style={{ backgroundColor: '#e0e0e0', position: 'relative' }}>
                    დახარვეზების მიზეზი
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        className="close-button"
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <IoClose />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        flow.map((item, index) => (
                            <React.Fragment key={index}>
                                <Grid container spacing={2} style={{ padding: "8px" }}>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle1" gutterBottom component="div">
                                            <MdPersonOutline style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                                            {userDetails[item.requesterId] ?
                                                `${userDetails[item.requesterId].firstName} ${userDetails[item.requesterId].lastName}`
                                                : 'Unavailable'}:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <Paper className="comment-box" elevation={3}>
                                            <Typography variant="body2" color="textSecondary">
                                                {item.comment}
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Divider />
                            </React.Fragment>
                        ))
                    )}
                    {error && <Typography color="error">{error}</Typography>}
                </DialogContent>


            </Dialog>
        </>
    );
};

export default ReturnCommentPopupFlowHeadOfDepartment;
